import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import markerGreen from "../../icons/marker_green.png"
import "./style.css";
import markerRed from "../../icons/marker_red.png"

const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: -23.548,
  lng: -46.638
};

const haversineDistance = (coords1, coords2) => {
  const toRad = (value) => (value * Math.PI) / 180;

  const R = 6371; // km
  const dLat = toRad(coords2.lat - coords1.lat);
  const dLng = toRad(coords2.lng - coords1.lng);
  const lat1 = toRad(coords1.lat);
  const lat2 = toRad(coords2.lat);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

const mapStyles = [
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'poi.business',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'poi.attraction',
    stylers: [{ visibility: 'off' }]
  }
];

const MapComponent = ({ apiKey, establishmentAddresses, setClosestLocation, location = null }) => {
  const [currentPosition, setCurrentPosition] = useState(null);
  const [establishmentPositions, setEstablishmentPositions] = useState([]);
  const [closestEstablishment, setClosestEstablishment] = useState(null);
  const [recheck, setRecheck] = useState(false);

  useEffect(() => {
    setRecheck(false);
    if (typeof window.google?.maps?.Geocoder !== "function") {
      setTimeout(() => setRecheck(true), 100);
      return () => { };
    }
    let positions = establishmentAddresses.map(u => { return { lat: parseFloat(u.lat), lng: parseFloat(u.lon) } });
    setEstablishmentPositions(positions);
    navigator.geolocation.getCurrentPosition((position) => {
      const userPosition = {
        lat: parseFloat(position.coords.latitude),
        lng: parseFloat(position.coords.longitude)
      };
      setCurrentPosition(userPosition);
      findClosestEstablishment(userPosition, positions);
    });


    const geocodeAddress = async (address) => {
      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: address }, (results, status) => {
          if (status === 'OK') {
            resolve({
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            });
          } else {
            reject('Geocode was not successful for the following reason: ' + status);
          }
        });
      });
    };

    const findClosestEstablishment = (userPosition, positions) => {
      let closest = null;
      let minDistance = Infinity;

      for (const position of positions) {
        const distance = haversineDistance(userPosition, position);
        if (distance < minDistance) {
          minDistance = distance;
          closest = position;
        }
      }
      if (closestEstablishment === null || location === null) {
        setClosestEstablishment(closest);
        positions.map((position, index) => {
          if (position === closest) {
            setClosestLocation(establishmentAddresses[index]);
          }
        });
      }
    };
  }, [recheck]);

  useEffect(() => {
    let index = 0;
    establishmentAddresses.map((e, i) => {
      if (e.api === location) {
        index = i;
      }
    });
    setClosestEstablishment(establishmentPositions[index]);
  }, [location, establishmentAddresses]);

  return (
    <LoadScript googleMapsApiKey={apiKey}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={closestEstablishment || center}
        zoom={15}
        options={{ styles: mapStyles }}
      >
        {establishmentPositions.map((position, index) => (
          <Marker
            key={index}
            position={position}
            label={establishmentAddresses[index]['nome']}
            icon={{ url: position === closestEstablishment ? markerGreen : markerRed }}
          />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
